const topBarMeasurements = new Map();
const updateNoticeMeasurements = new Map();

const safeMax = measurements => Math.max(0, ...measurements.values());

function syncTopBarMeasurement() {
  if (typeof document === 'undefined') return;
  document.documentElement.style.setProperty(
    '--top-bar-visible-height',
    `${Math.ceil(safeMax(topBarMeasurements))}px`
  );
}

function syncUpdateNoticeMeasurement() {
  if (typeof document === 'undefined') return;
  const height = Math.ceil(safeMax(updateNoticeMeasurements));
  document.documentElement.style.setProperty(
    '--app-update-notice-reserve',
    height > 0 ? `calc(${height}px + var(--top-stack-gap))` : '0px'
  );
}

export function setTopBarMeasurement(owner, height) {
  topBarMeasurements.set(owner, Math.max(0, Number(height) || 0));
  syncTopBarMeasurement();
}

export function clearTopBarMeasurement(owner) {
  topBarMeasurements.delete(owner);
  syncTopBarMeasurement();
}

export function setUpdateNoticeMeasurement(owner, height) {
  updateNoticeMeasurements.set(owner, Math.max(0, Number(height) || 0));
  syncUpdateNoticeMeasurement();
}

export function clearUpdateNoticeMeasurement(owner) {
  updateNoticeMeasurements.delete(owner);
  syncUpdateNoticeMeasurement();
}

export function resetFloatingTopStackForTests() {
  topBarMeasurements.clear();
  updateNoticeMeasurements.clear();
  syncTopBarMeasurement();
  syncUpdateNoticeMeasurement();
}
